import { EventEmitter, OnChanges, SimpleChanges, SimpleChange } from '@angular/core';
import { FormControl } from '@angular/forms';
var SearchBarComponent = /** @class */ (function () {
    function SearchBarComponent() {
        this.searchField = new FormControl('');
        this.onSearch = new EventEmitter();
    }
    Object.defineProperty(SearchBarComponent.prototype, "onNavigation", {
        set: function (url) {
            if (!/search\/(.*)/.test(url))
                this.searchField.setValue('');
        },
        enumerable: true,
        configurable: true
    });
    SearchBarComponent.prototype.ngOnChanges = function (changes) {
        var searchTermChange = changes.searchTerm;
        if (searchTermChange && !searchTermChange.firstChange) {
            this.searchField.setValue(searchTermChange.currentValue);
        }
    };
    SearchBarComponent.prototype.keypress = function (event) {
        if ((event.charCode || event.keyCode) === 13 && this.searchField.value)
            this.doSearch();
    };
    SearchBarComponent.prototype.doSearch = function () {
        if (this.searchField.value) {
            this.onSearch.emit(this.searchField.value);
        }
    };
    return SearchBarComponent;
}());
export { SearchBarComponent };
